import React from 'react';

const ProjectsSection: React.FC = () => {
  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-primary mb-4">Recent Projects</h2>
          <p className="text-xl text-gray-600">See Our Work Across Ontario</p>
        </div>

        {/* Individual Projects */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="images/pergolas/pic1.webp" 
              alt="Mississauga pergola installation - 12x16 poolside pergola with motorized louvers and LED lighting"
              className="w-full h-48 object-cover" 
              loading="lazy"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-primary mb-2">
                Mississauga, ON – Evie Solis Pergola
              </h3>
              <p className="text-gray-600">
                12×16 poolside pergola with motorized louvers & LED lighting
              </p>
            </div>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="images/pergolas/pic2.webp" 
              alt="Burlington pergola installation - 10x14 garden pergola with integrated screens and heating"
              className="w-full h-48 object-cover" 
              loading="lazy"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-primary mb-2">
                Burlington, ON – Evie Solis Pergola
              </h3>
              <p className="text-gray-600">
                10×14 garden pergola with integrated screens & heating
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
